<template>
    <div
        class="skagen-consent-general"
        :class="{ 'skagen-consent-overlay': !blockViewMode }"
    >
        <div
            :class="[
                blockViewMode
                    ? 'container'
                    : 'container skagen-consent-container',
            ]"
        >
            <h2>{{ consentTexts.heading }}</h2>
            <div class="text--gdpr">
                <span v-html="consentTexts.generalMainIntro"></span>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <button
                        class="btn btn-block btn-primary"
                        v-on:click="acceptAll()"
                    >
                        {{ consentTexts.generalButtonAccept }}
                    </button>
                </div>
                <div class="col-sm-4" v-if="showRejectButton">
                    <button
                        class="btn btn-block btn-primary"
                        v-on:click="rejectAll()"
                    >
                        {{ consentTexts.generalButtonReject }}
                    </button>
                </div>
                <div class="col-sm-4">
                    <button
                        class="btn btn-block btn-link"
                        v-on:click="showDetails()"
                    >
                        {{ consentTexts.generalButtonChange }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'GeneralConsent',
    props: {
        blockViewMode: { type: Boolean },
        consentTexts: { type: Object },
    },
    computed: {
        showRejectButton() {
            return this.consentTexts.generalButtonReject;
        },
    },
    methods: {
        showDetails() {
            this.$emit('consent:showDetails');
        },
        rejectAll() {
            this.$emit('consent:rejectAll');
        },
        acceptAll() {
            this.$emit('consent:acceptAll');
        },
    },
};
</script>
<style></style>
